import { useNavigate } from 'react-router-dom';
import settingsIcon from '../../static/icons/icon_settings.svg';

const TopBarSettingsButton = () => {
    const navigate = useNavigate();

    const viewSettings = () => {
        navigate('settings');
    };

    return (
        <img className="icon-button" src={settingsIcon} alt="settings icon" onClick={viewSettings}/>
    );
};

export default TopBarSettingsButton;
